import { render, staticRenderFns } from "./gameEventConfig.vue?vue&type=template&id=dfa7bd9c&"
import script from "./gameEventConfig.vue?vue&type=script&lang=js&"
export * from "./gameEventConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfa7bd9c')) {
      api.createRecord('dfa7bd9c', component.options)
    } else {
      api.reload('dfa7bd9c', component.options)
    }
    module.hot.accept("./gameEventConfig.vue?vue&type=template&id=dfa7bd9c&", function () {
      api.rerender('dfa7bd9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameManager/gameEventConfig.vue"
export default component.exports